import React from 'react';
import InlineFormWrapper from './inline-form-wrapper';
import Glyph from 'components/glyph';

class MemberWrapper extends React.Component {
  render() {
    return (
      <li className="member" data-title={this.props.email} data-member={this.props.memberId}>
        <h3 className="list-box-head">
          <MemberDeleteButton
            isVisible={this.props.showDeleteButton}
            onDeleteMemberClick={this.props.onDeleteMemberClick}
            memberId={this.props.memberId}
            email={this.props.email}
            isCurrentMember={this.props.isCurrentMember}
          />
          <MemberEditButton isVisible={this.props.showEditButton} onEditMemberClick={this.props.onEditMemberClick} />
          <Glyph name="user-1" /> {this.props.email} <CurrentMemberTag isCurrentMember={this.props.isCurrentMember} />
        </h3>

        <div>
          <InlineFormWrapper memberId={this.props.memberId} shouldHaveInlineForm={!this.props.isEditAllForm}>
            <div className={`list-box sectioned permissions-box ${this.props.permissionsBoxCss}`}>

              {this.props.children}

            </div>

            {
              (this.props.showFormButtons && this.props.errorMessage) &&
                <div className="error-messages"><p>{this.props.errorMessage}</p></div>
            }

            {
              this.props.showFormButtons &&
                <p className="submission squared mod-inline-edit">
                  <EditableNotificationsOnlyMessage isCurrentMember={this.props.isCurrentMember} />

                  <button className="mod-primary" onClick={this.props.onSaveMemberChanges}>
                    {this.props.saveButtonText}
                  </button> <button onClick={this.props.onEditMemberCancel}>
                    {this.props.cancelButtonText}
                  </button>
                </p>
            }
          </InlineFormWrapper>
        </div>
      </li>
    );
  }
}



// *********************************************************************************
// Functional components
// *********************************************************************************



// responsible for returning the "(you)" stamp next to the current member
// *********************************************************************************
function CurrentMemberTag(props) {
  return (
    props.isCurrentMember &&
      <small>(you)</small>
  );
}

// responsible for the current member notice on the form submit bar
// *********************************************************************************
function EditableNotificationsOnlyMessage(props) {
  return (
    props.isCurrentMember &&
      <span className="submit-message">
        You can change your email notifications, but only other team members can remove or change your access.
      </span>
  );
}

// responsible for rendering the delete button, only for non-current members
// *********************************************************************************
function MemberDeleteButton(props) {
  return (
    !props.isCurrentMember && props.isVisible &&
      <a className="sm right btn-link red" onClick={props.onDeleteMemberClick}>
        <Glyph name="trash-3" type="stroke" className="lefted" /> Remove
      </a>
  );
}

// responsible for rendering the member edit button
// *********************************************************************************
function MemberEditButton(props) {
  return (
    props.isVisible &&
      <a onClick={props.onEditMemberClick} className="btn-link sm right mod-edit-member">
        <Glyph name="compose-2" type="stroke" className="lefted" /> Edit
      </a>
  );
}

export default MemberWrapper;
